import { CommonModule } from '@angular/common';
import {UnitOverviewLinkPipe} from "../unit-overview.pipe";

// Group everything you use "almost everywhere" here
export const COMMON_IMPORTS = [
    CommonModule,
    UnitOverviewLinkPipe
] as const;
